import { Pagination } from '@eventbrite/eds-pagination';
import { HAS_WINDOW } from '@eventbrite/feature-detection';
import React from 'react';

interface SearchFooterProps {
    currentPage: number;
    totalNumResults: number;
    hasEventResults?: boolean;
    handleGetPage: Function;
}

export class SearchFooter extends React.Component<SearchFooterProps> {
    _onGetPage = (pageNumber: number) => {
        const { handleGetPage } = this.props;

        if (HAS_WINDOW) {
            window.scrollTo(0, 0);
        }
        // Offset by -1 because our Redux pagination assumes pages start at 0, EDS assumes pages start at 1
        handleGetPage(pageNumber);
    };

    render() {
        const { currentPage, totalNumResults, hasEventResults } = this.props;

        if (!hasEventResults) {
            return null;
        }

        return (
            <footer className="eds-l-mar-bot-10">
                <Pagination
                    pageNumber={currentPage}
                    totalNumResults={totalNumResults}
                    size="minimal"
                    // eslint-disable-next-line react/jsx-handler-names
                    onSelected={this._onGetPage}
                />
            </footer>
        );
    }
}
